import {
  Box,
  Divider,
  Step,
  StepConnector,
  StepContent,
  StepIconProps,
  StepLabel,
  Stepper,
  Theme,
  makeStyles,
  createStyles,
} from "@material-ui/core"
import React from "react"
import {IStep} from "./FunctionDialog"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"

interface ICustomStepperProps {
  activeStep: number
  activeSubstep?: number
  readonly changeActiveStep: (step: number) => void
  steps: IStep[]
}

const useStyles = makeStyles(({spacing, palette}: Theme) =>
  createStyles({
    stepIconCompleted: {
      color: "rgba(0,0,0,0.38)!important"
    },
    lineVertical: {
      height: "100%"
    },
    noPadding: {display: "flex", padding: spacing(0)},
    substepIcon: {
      transform: "scale(0.4)",
      color: "rgba(0, 0, 0, 0.38)"
    },
    substepIconCompleted: {
      transform: "scale(0.4)",
      color: palette.primary.main
    },
    substepIconActive: {
      transform: "scale(0.4)",
      color: palette.primary.main
    },
    step: {
      cursor: "pointer"
    }
  })
)
const SubStepIcon = ({completed, active}: StepIconProps) => {
  const classes = useStyles()
  if (active) {
    return <FiberManualRecordIcon className={classes.substepIconActive} />
  } else if (completed) {
    return <FiberManualRecordIcon className={classes.substepIconCompleted} />
  } else {
    return <FiberManualRecordIcon className={classes.substepIcon} />
  }
}
const CustomStepper: React.FunctionComponent<ICustomStepperProps> = ({
  activeStep,
  steps,
  activeSubstep,
  changeActiveStep
}) => {
  const classes = useStyles()
  return (
    <Stepper
      activeStep={activeStep}
      nonLinear
      orientation="vertical"
      connector={
        <StepConnector classes={{lineVertical: classes.lineVertical}} />
      }
    >
      {steps.map((step, index) => (
        <Step key={index} className={classes.step}>
          <Box mt={1} />
          <StepLabel
            onClick={() => changeActiveStep(index)}
            classes={{completed: classes.stepIconCompleted}}
          >
            {step.label}
          </StepLabel>
          <StepContent />
          {step.subSteps && activeSubstep && (
            <Stepper className={classes.noPadding}>
              <Divider
                orientation="vertical"
                className={classes.lineVertical}
              />
              {step.subSteps.map((substep, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={SubStepIcon}>
                    {substep.label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}
        </Step>
      ))}
    </Stepper>
  )
}

export default CustomStepper
